// extracted by mini-css-extract-plugin
module.exports = {"time":"SelectedTime_time__34VQg"};